// extracted by mini-css-extract-plugin
module.exports = {"Tooltip":"tooltip_Tooltip__63gDR","Arrow":"tooltip_Arrow__NJw7U"};